import { lazy } from "react"
import { IApparelInstance } from "store/apis/apparelAPI"

export const APPAREL_MODALS = {
  apparelDetails: {
    component: lazy(() => import("modals/ui/apparel/ApparelDetails")),
    params: {} as {
      apparelInstance: IApparelInstance
      fromCraft?: boolean
    }
  },
  setItemDetails: {
    component: lazy(() => import("modals/ui/apparel/SetItemDetails")),
    params: {} as {
      apparelInstance: IApparelInstance
      highlightedApparelId?: string
    }
  }
} as const
